import { CustomRegistry } from "@nemuru-eng/js-api-client";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { ONBOARDING_FULFILLED_BY_TYPES } from "../../../config";

export const useWelcomeMessage = ({
  onHideMessage,
  processContextState,
  dispatch,
}) => {
  const { merchant, appStarted, participant, currentSection, sectionsArray } =
    processContextState;

  const {
    state: { agent },
  } = useContext(AuthContext);

  const [hidingLogo, setHidingLogo] = useState(false);
  const [currentProgressStepIndex, setCurrentProgressStepIndex] =
    useState(null);

  useEffect(() => {
    setTimeout(() => {
      setHidingLogo(true);
    }, logoDuration);
  }, []);

  useEffect(() => {
    currentSection && sectionsArray && findCurrentProgressStepIndex();
  }, [sectionsArray]);

  useEffect(() => {
    if (!appStarted && hidingMessage) {
      startApp();
    }
  }, [appStarted, hidingMessage]);

  const hidingMessage = false;
  const logoDuration = 1000;

  const startApp = () => {
    dispatch({
      type: "START_APP",
    });
    if (onHideMessage) onHideMessage();
  };

  const findCurrentProgressStepIndex = () => {
    sectionsArray?.map((step, i) => {
      if (step.id === currentSection.id) {
        setCurrentProgressStepIndex(i);
      }
    });
  };

  const getProposedByValue = () => {
    switch (agent.custom_registry) {
      case CustomRegistry.VAILLANT:
        return agent.name;
      default:
        return merchant?.registration_fields?.business_name;
    }
  };

  const onBoardingByBorrower =
    participant.onboardingFulfilledBy ===
      ONBOARDING_FULFILLED_BY_TYPES.BORROWER_POS ||
    participant.onboardingFulfilledBy ===
      ONBOARDING_FULFILLED_BY_TYPES.CLIENT_SIDE_KYC_SIGNATURE;

  return {
    getProposedByValue,
    hidingLogo,
    hidingMessage,
    startApp,
    onBoardingByBorrower,
    currentProgressStepIndex,
  };
};
